module.exports = __webpack_public_path__ + "media/file_icons/png-2abf7e7a.svg";